module.exports = __webpack_public_path__ + "static/media/image_61.04520017.png";